import React, { useState, useEffect, useContext, useRef } from "react";
import HeaderStroke from "../HeaderStroke";
import { ReactComponent as Back } from "../../assets/novosicones/Destaques/Back.svg";
import { ReactComponent as Forward } from "../../assets/novosicones/Destaques/Forward.svg";
import { ContextoListaApartamentos } from "../ApartamentList/contextoImoveis";
import changeImageUrl from "../../Utils/changeUrl";
import "./styles.scss";
const DestaquesComponent = ({ destaques, idSelecionado }) => {
  const [itemAtual, setItemAtual] = useState(idSelecionado);

  const [destaqueAtual, setDestaqueAtual] = useState([]);

  const [errorImg, setErrorImg] = useState(false);

  const { tema } = useContext(ContextoListaApartamentos);

  useEffect(() => {
    executeScroll();
  }, []);

  useEffect(() => {
    if (destaques.data) setDestaqueAtual(destaques.data[itemAtual]);
    else setDestaqueAtual(destaques[itemAtual]);

    if (errorImg) setErrorImg(false);
  }, [itemAtual]);

  var arrowDisabled = { fill: "#d1d1d1" };
  var itemMaiorQueZero = false;
  if (itemAtual > 0) itemMaiorQueZero = true;
  var ultimoItem = false;
  if (itemAtual == destaques.length - 1) ultimoItem = true;

  // para scroll
  const refCalendarioAcompanhamento = useRef(null);
  const executeScroll = () =>
    refCalendarioAcompanhamento.current.scrollIntoView();
  // fim scroll

  if (!destaques) return null;

  return (
    <div>
      <HeaderStroke name={"Destaques"} msgDadosCadastrais={false} />
      <div className="centralized">
        <div className="centralized-column destaquesUnico">
          <div
            className="centralized-space-between destaquesUnico__navegacao"
            ref={refCalendarioAcompanhamento}
          >
            <button
              disabled={itemMaiorQueZero ? false : true}
              onClick={() => {
                itemAtual > 0 && setItemAtual(itemAtual - 1);
              }}
              id="btnLerDestaqueAnterior"
            >
              <Back
                style={
                  itemMaiorQueZero ? { fill: tema.primaryColor } : arrowDisabled
                }
              />
            </button>
            <button
              disabled={ultimoItem ? true : false}
              onClick={() => {
                !ultimoItem && setItemAtual(itemAtual + 1);
              }}
              id="btnLerDestaquePosterior"
            >
              <Forward
                style={ultimoItem ? arrowDisabled : { fill: tema.primaryColor }}
              />
            </button>
          </div>
          <div className="destaquesUnico__content">
            <h2>{destaqueAtual?.Titulo}</h2>
            <p className="destaquesUnico__content__resumo">
              {destaqueAtual?.Resumo}
            </p>
            {changeImageUrl(destaqueAtual?.Imagem) && !errorImg && (
              <img
                src={changeImageUrl(destaqueAtual?.Imagem)}
                onError={() => {
                  setErrorImg(true);
                }}
                alt={""}
                loading="lazy"
              />
            )}
            <p>{destaqueAtual?.CorpoDestaque}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestaquesComponent;
